export default "/images/global_credit.svg?1e20fca2b75b49b7d8cbeb7da8980bf6";